/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class DiscordOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    error={this.props.error}
                    headerCopy="Select a Channel"/>
                <ChooserMain
                    {...this.props}/>
            </div>
        );
    }
}

DiscordOutput.displayName = "DiscordOutput";

export default DiscordOutput;
